import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Modal } from 'semantic-ui-react';
import i18next from 'i18next';

const MenusPicker = (props) => {
    const { open, handleMenuPicked } = props;
    const chainId = useSelector(state => state.businessApp.chainId);
    const menus = useSelector(state => state.businessApp.restaurants.filter(r => r.ownerId == chainId).reduce((menus, branch) => {
        const { menuId, name } = branch;
        if (!menuId) return menus;

        if (!menus[menuId]) {
            menus[menuId] = [];
        }
        menus[menuId].push(name);
        return menus;
    }, {}));

    if (!Object.keys(menus).length) {
        return null;
    }

    return (
        <Modal open={open} dimmer="blurring">
            <Modal.Header>{i18next.t('menu.pickMenu')}</Modal.Header>
            <Modal.Content>
                <Card.Group style={{ display: 'flex', justifyContent: 'center' }}>
                    {Object.keys(menus).map(menuId => (
                        <Card
                            key={menuId}
                            link
                            header={menuId}
                            meta='Menu'
                            description={menus[menuId].join(', ')}
                            onClick={() => handleMenuPicked(menuId)}
                        />
                    ))}
                </Card.Group>
            </Modal.Content>
        </Modal>
    );
};

MenusPicker.propTypes = {
    
    open: PropTypes.bool,
    handleMenuPicked: PropTypes.func
};

export default MenusPicker;
